<template>
  <a-card>
    <div class="mb15" v-if="allowEdit">
      <multiple-file-upload
        v-model:value="fileList"
        :uploaded-count="uploadedFileList.length"
        @ok="onOk"
        v-perm="uploadAccess"
      ></multiple-file-upload>
    </div>
    <biz-file-table
      ref="bizFileTable"
      :allow-edit="allowEdit"
      :biz-id="bizId"
      :biz-type="bizType"
      :download-access="downloadAccess"
      :delete-access="deleteAccess"
    ></biz-file-table>
  </a-card>
</template>

<script lang="ts">
import { computed, defineComponent, ref, onMounted } from "vue";
import { BizFileService } from "@/core";
import { FileRecord } from "@/core/services/file-upload.interface";
import MultipleFileUpload from "../multiple-file-upload/index.vue";
import BizFileTable from "../biz-file-table/index.vue";
import { notifyEmitter } from "@/utils/emitter";
export default defineComponent({
  isGlobal: true,
  name: "AttachmentTableUpload",
  components: { MultipleFileUpload, BizFileTable },
  props: {
    bizId: {
      type: String,
      require: true,
    },
    bizType: {
      type: String,
      require: true,
    },
    allowEdit: {
      type: Boolean,
      default: false,
    },
    uploadAccess: {
      type: String,
    },
    downloadAccess: {
      type: String,
    },
    deleteAccess: {
      type: String,
    },
  },
  setup(props) {
    const bizFileTable = ref();
    const fileList = ref<FileRecord[]>([]);
    const uploadedFileList = computed(() => {
      if (bizFileTable && bizFileTable.value) {
        return bizFileTable.value.fileList;
      }
      return [];
    });
    const { run } = BizFileService.useCreateUploadApi();

    const onOk = async (uploadedFileList) => {
      bizFileTable.value.loading = true;
      if (uploadedFileList.length > 0) {
        const files = uploadedFileList.map((item) => {
          item.bizId = props.bizId;
          item.bizType = props.bizType;
          return item;
        });
        const res = await run(files, props.bizId, props.bizType);
        bizFileTable.value.loading = false;
        if (res.respCode === "0000") {
          fileList.value = [];
          bizFileTable.value.reload();
          notifyEmitter.emit("emit-notify", "");
          //通知其他页面上传附件成功了
          notifyEmitter.emit("upload-file-success", "");
        }
      }
    };

    return {
      bizFileTable,
      uploadedFileList,
      fileList,
      onOk,
    };
  },
});
</script>
